import Swiper from "swiper";
import { Pagination } from "swiper/modules";

export const initProductCardFiltersSwiper = () => {
  const swiperElement = document.querySelector(".product-card-swiper-filters") as HTMLElement;
  if (!swiperElement) return;

  // Check if element is visible
  if (swiperElement.offsetParent === null) return;

  const swiper = new Swiper(".product-card-swiper-filters", {
    modules: [Pagination],
    spaceBetween: 16,
    slidesPerView: 'auto',
    centeredSlides: false,
    pagination: {
      el: ".product-card-swiper-filters .swiper-pagination",
      clickable: true,
    },
  });
};